export default __webpack_public_path__ + "static/media/landing_background.3eaf875d.png";